/* eslint-disable */
  
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.colour = {}; 
  /**************************************************************************************************************/
    Blockly.Blocks['colour_picker'] = {
        init: function() {
          this.appendDummyInput()
              .appendField(new Blockly.FieldColour("#ff0000"), "COLOUR");
          this.setOutput(true, null);
          //this.setColour(230);
       this.setTooltip("");
       this.setHelpUrl("");
       this.setMovable(false);

        }
      };
}